import { createContext, useContext } from 'react';
export const OAuthButtonContext = /*#__PURE__*/createContext(null);
export const useOAuthButtonContext = () => {
  const context = useContext(OAuthButtonContext);
  if (context === undefined || context === null) {
    throw new Error('This component must be used within a OAuthButton.Root component');
  }
  return context;
};